<script setup lang="ts"></script>

<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1567_26038)">
      <path d="M14 12L10 16V8L14 12Z" fill="black" />
    </g>
    <defs>
      <clipPath id="clip0_1567_26038">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<style scoped lang="scss"></style>
